import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { api } from '../../app/Api/ApiSlice';

const StoreSuggest = () => {
    const navigate = useNavigate();
    const { name } = useParams();

    const [text, setText] = useState("");
    const [files, setFiles] = useState([]);
    const [imagePreviews, setImagePreviews] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const addFiles = (e) => {
        const selectedFiles = Array.from(e.target.files);
        setFiles(selectedFiles);

        const previews = selectedFiles.map(file => URL.createObjectURL(file));
        setImagePreviews(previews);
    };

    useEffect(() => {
        return () => {
            imagePreviews.forEach(url => URL.revokeObjectURL(url));
        };
    }, [imagePreviews]);

    const handleRemove = (index) => {
        setFiles(prev => prev.filter((_, i) => i !== index));
        setImagePreviews(prev => prev.filter((_, i) => i !== index));
    };

    const uploadToS3 = async (file) => {
        const presignRes = await api.post("/uploads/presign", {
            filename: file.name,
            contentType: file.type,
        });

        const { uploadUrl, key } = presignRes.data;

        const res = await fetch(uploadUrl, {
            method: "PUT",
            headers: { "Content-Type": file.type },
            body: file,
        });

        if (!res.ok) throw new Error(`Upload failed: ${file.name}`);

        const baseType = file.type.split("/")[0];

        return {
            key,
            type:
                baseType === "image"
                    ? "image"
                    : baseType === "video"
                        ? "video"
                        : "document",
            mimeType: file.type,
            name: file.name,
            size: file.size,
        };
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!text.trim() && files.length === 0) {
            toast.error("Cannot submit empty content");
            return;
        }

        try {
            setIsLoading(true);

            const uploadedFilesMetadata = await Promise.all(
                files.map((f) => uploadToS3(f))
            );

            const payload = {
                text,
                files: uploadedFilesMetadata,
            };

            await api.post(`/stores/${name}/suggestions`, payload);

            toast.success("suggestion message sent");
        } catch (error) {
            toast.error(error.response?.data?.message || "Upload failed");
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="form-wrapper create-form">
            <h3 className='form-title'>suggestion box</h3>

            <form onSubmit={handleSubmit}>
                <textarea
                    placeholder='Your identity will be hidden'
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                />

                <div className="images-preview">
                    {imagePreviews.map((preview, i) => (
                        <div key={i}>
                            <img src={preview} alt='' />
                            <button type='button' onClick={() => handleRemove(i)}>
                                Remove
                            </button>
                        </div>
                    ))}
                </div>

                <input
                    type="file"
                    multiple
                    accept="image/*"
                    onChange={addFiles}
                />

                <button type='submit' disabled={isLoading}>
                    {isLoading ? "Loading..." : "Save"}
                </button>
            </form>
        </div>
    );
};

export default StoreSuggest;
